<div class="loginCard" style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%; background-color: #f0f0f0;">
    <div class="card" style="padding: 20px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5); border-radius: 20px;">
        <div class="container">
            <div class="card-header-wrapper">
                <div style="display: flex; justify-content: center;">
                    <img [src]="logotipo" alt="Logo" style="width: 50%; height: auto;">
                </div>
                <br>
                <span></span>
            </div>
        </div>

        <div class="card-component">
            <!-- Formulário com evento keydown.enter para submeter com "Enter" -->
            <form class="k-form k-form-horizontal" style="max-width: 600px; width: 600px;" [formGroup]="formGroup"
                (keydown.enter)="onSubmit()">

                <fieldset class="k-form-fieldset">

                    <!-- Email -->
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="login" text="User "> </kendo-label>
                        <kendo-textbox formControlName="login" #login required> </kendo-textbox>
                        <kendo-formerror> {{ customMsgService.translate('erroLoginNecessario') }} </kendo-formerror>
                    </kendo-formfield>

                    <!-- Password -->
                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="password" text="Password"> </kendo-label>
                        <kendo-textbox formControlName="password" #password="kendoTextBox" required>
                            <ng-template kendoTextBoxSuffixTemplate>
                                <kendo-textbox-separator></kendo-textbox-separator>
                                <button kendoButton fillMode="flat" icon="eye" (click)="selectedChange()"></button>
                            </ng-template>
                        </kendo-textbox>
                        <kendo-formerror> {{ customMsgService.translate('erroPasswordNecessaria') }} </kendo-formerror>
                    </kendo-formfield>
                    <!-- Botão de Login -->
                    <button class="btnLogin" kendoButton (click)="onSubmit()" themeColor="primary"
                        [disabled]="!formGroup.valid" style="background-color: #0066ff; color: white;">
                        Login
                    </button>
                    
                    <!-- Botão de Esqueceu Password -->
                    <div class="forgetPW">
                        <a class="linksmall" routerLink="/recoverpass" routerLinkActive="active">
                            {{ customMsgService.translate('esqueceuPassword') }}
                        </a>
                    </div>

                </fieldset>

            </form>
        </div>
    </div>
</div>
